/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ wins: NonNullable<unknown> }} Profile_Hof_MemberInputs */



/**
* | output |
* | --- |
* | "Hall of Fame — {wins} wins" |
*
* @param {Profile_Hof_MemberInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_hof_member = /** @type {((inputs: Profile_Hof_MemberInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Hof_MemberInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Hall of Fame — ${i?.wins} victoires`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Hall of Fame — ${i?.wins} victorias`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Hall da Fama — ${i?.wins} vitórias`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Hall of Fame — ${i?.wins} vittorie`)
	return /** @type {LocalizedString} */ (`Hall of Fame — ${i?.wins} wins`)
});